<form [formGroup]="shopManagementFilterForm">
  <div class="form-content">
    <div class="pure-g">
      <!-- Shop Codes -->
      <div class="pure-u-24-24 p-b-16">
        <app-aems-multiline-tag-input
          label="Shop Codes"
          [transformToUppercase]="true"
          placeholder="Enter shop codes"
          [regex]="shopCodeRegex"
          formControlName="shopCode">
        </app-aems-multiline-tag-input>
      </div>

      <!-- Part Supplier Type -->
      <div class="pure-u-md-12-24 p-b-16 p-r-16">
        <mc-multi-select
          label="Part Supplier Type"
          fit="medium"
          width="100"
          placeholder="Select an Option"
          ngDefaultControl
          formControlName="partSupplierType">
          @for (partSupplierType of partSupplierTypeList; track partSupplierType.code) {
            <mc-option [value]="partSupplierType.code" [attr.data-cy]="partSupplierType.code">
              {{ partSupplierType.description }}
            </mc-option>
          }
        </mc-multi-select>
      </div>

      <!-- Active Status -->
      <div class="pure-u-md-12-24 p-b-16 p-r-16">
        <mc-checkbox-group legend="Status">
          <div style="display: flex; gap: 16px; align-items: center">
            <mc-checkbox
              value="true"
              label="Active"
              [checked]="isValueSelected('isActive', true)"
              (change)="onCheckChange('isActive', true)">
            </mc-checkbox>

            <mc-checkbox
              value="false"
              label="Inactive"
              [checked]="isValueSelected('isActive', false)"
              (change)="onCheckChange('isActive', false)">
            </mc-checkbox>
          </div>
        </mc-checkbox-group>
      </div>

      <!-- Shop Location -->
      <div class="pure-u-md-12-24 p-b-16 p-r-16">
        <mc-typeahead-multi-select
          label="Shop Location"
          placeholder="Type or select shop location"
          fit="medium"
          width="100%"
          name="shopLocation"
          [data]="locationCodesList"
          [selecteddata]="selectedLocations"
          (optionselected)="onLocationSelected($event)"
          (clearbuttonclick)="onLocationCleared()">
        </mc-typeahead-multi-select>
      </div>
    </div>
  </div>

  <div class="pure-u-md-24-24 utility-buttons">
    <mc-button label="Apply Filters" appearance="primary" fit="medium" (click)="applyFilters()"> </mc-button>

    <mc-button label="Clear Filters" appearance="neutral" fit="medium" (click)="clearFilters()"> </mc-button>
  </div>
</form>
